import GlobalQuickJump from "../../../../../global/GlobalQuickJump";

export default function OfficeMaintenanceQuickJumpSection(props) {
  return <GlobalQuickJump {...props} />;
}
